import { Puzzle, Webhook, Plug } from 'lucide-react';

const INTEGRATIONS = [
  { name: 'MyCERT Threat Feed', type: 'API', status: 'connected', description: 'Malaysian CERT threat intelligence data', lastSync: '8 min ago' },
  { name: 'n8n Workflow Automation', type: 'Webhook', status: 'connected', description: 'Automated response playbook execution', lastSync: '2 min ago' },
  { name: 'Slack Notifications', type: 'Webhook', status: 'connected', description: 'Real-time alert notifications to #soc-alerts', lastSync: 'Active' },
  { name: 'Microsoft Teams', type: 'Webhook', status: 'disconnected', description: 'Alert forwarding to Teams channel', lastSync: '—' },
  { name: 'AlienVault OTX', type: 'API', status: 'error', description: 'Open Threat Exchange indicator feed', lastSync: '3 hours ago' },
  { name: 'PagerDuty', type: 'API', status: 'disconnected', description: 'On-call escalation for critical alerts', lastSync: '—' },
  { name: 'Jira Service Desk', type: 'API', status: 'connected', description: 'Auto-create tickets from drift alerts', lastSync: '15 min ago' },
  { name: 'Telegram Bot', type: 'Webhook', status: 'disconnected', description: 'Mobile alert delivery via Telegram', lastSync: '—' },
];

const STATUS_STYLES = {
  connected: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  disconnected: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
  error: 'bg-red-500/20 text-red-400 border-red-500/30',
};

const STATUS_DOT = {
  connected: 'bg-emerald-400',
  disconnected: 'bg-gray-600',
  error: 'bg-red-400',
};

const Integrations = () => (
  <div className="p-6 space-y-6">
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-white">Integration Setup</h1>
      <p className="text-sm text-gray-500 mt-1">
        Connectivity configuration for MyCERT, n8n, and webhooks · PRD: ADM (Section 7.4)
      </p>
    </div>

    <div className="bg-gray-900 border border-gray-700/50 rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Puzzle className="w-5 h-5 text-cyan-400" />
          <h2 className="text-lg font-semibold text-white">Connectors</h2>
        </div>
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-500/20 text-cyan-400 border border-cyan-500/30">
          Coming Soon
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {INTEGRATIONS.map((integration, i) => (
          <div key={i} className="bg-gray-950/60 border border-gray-800 rounded-lg p-4 hover:border-gray-700 transition-colors">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-gray-800 flex items-center justify-center">
                  {integration.type === 'Webhook' ? (
                    <Webhook className="w-4 h-4 text-cyan-400" />
                  ) : (
                    <Plug className="w-4 h-4 text-cyan-400" />
                  )}
                </div>
                <div>
                  <p className="text-sm font-medium text-white">{integration.name}</p>
                  <p className="text-xs text-gray-500 mt-0.5">{integration.description}</p>
                </div>
              </div>
              <span className={`flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium border ${STATUS_STYLES[integration.status]}`}>
                <span className={`w-1.5 h-1.5 rounded-full ${STATUS_DOT[integration.status]}`} />
                {integration.status}
              </span>
            </div>
            <div className="flex items-center justify-between pt-3 border-t border-gray-800/50">
              <span className="text-xs text-gray-600 font-mono">
                {integration.lastSync === 'Active' ? (
                  <span className="text-emerald-400">{integration.lastSync}</span>
                ) : (
                  `Last sync: ${integration.lastSync}`
                )}
              </span>
              <div className="flex items-center gap-2">
                {integration.status === 'connected' ? (
                  <button className="text-xs text-gray-500 hover:text-red-400 transition-colors cursor-pointer" disabled>
                    Disconnect
                  </button>
                ) : (
                  <button className="text-xs text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer" disabled>
                    Connect
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Integrations;
